import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { PublicComponent } from './public.component';
import { HandlerAuthComponent } from './handler/handler-auth.component';
import { BalcaoComponent } from '../private/balcao/balcao/balcao.component';

const routes: Routes = [
  {
    path: '', 
    component: PublicComponent,
    children: [
       { path: 'balcao', component: BalcaoComponent },
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'login/:step',
        component: LoginComponent
      },
      {
        path: 'RedefinirSenha',
        component: LoginComponent
      },
      {
        path: 'Handler/:tokenId',
        component: HandlerAuthComponent
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: '**', redirectTo: '404' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicRoutingModule { }
